// extracted by mini-css-extract-plugin
export default {"title":"TermsOfUse_title__jQ30H","message":"TermsOfUse_message__-DoEa"};